import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './pages/plugin';
import LandingPage from './pages/landing-page';
import { ChatProvider } from "./contexts/ChatProvider";
import { LocaleProvider } from "./contexts/LocaleProvider";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  });

  Sentry.setTag('component', 'client');
}

const container = document.getElementById('root');
const root = createRoot(container);


root.render(
  <React.StrictMode>
    <LocaleProvider>
      <ChatProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/plugin" element={<App />} />
          </Routes>
        </Router>
      </ChatProvider>
    </LocaleProvider>
  </React.StrictMode>
);